/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import { IRootState } from 'store';
import { connect, useDispatch } from 'react-redux';
import { IScholars } from 'types';
import { hideLiteracyModal, showLiteracyModal } from 'actions/app-state';
import _ from 'lodash';
import buttons from 'style/buttons.module.scss';
import Game from './icons/iconGame';
import Dashboard from './icons/dashboard';
import TimeSquare from './icons/timeSquare';
import { ReactComponent as Profile } from './icons/Profile.svg';
import styles from './index.module.scss';
import UserInfo from './userInfo';

const mapStateToProps = (state: IRootState) => ({
  userType: state.users.userData?.type,
  units: state.scholars.units,
  activeScholarId: state.users.userData?.activeScholarId,
  literacyModalResult: state.appState.literacyModalResult,
});

interface ILocationState {
  mode: string;
}
type Props = ReturnType<typeof mapStateToProps>;

let literacyModalIssuer: string;

const SideBar: React.FC<Props> = ({
  units,
  activeScholarId,
  userType,
  literacyModalResult,
}) => {
  const location = useLocation<ILocationState>();
  const [isSublinkMapVisible, setIsSublinkMapVisible] = useState(false);
  const [isSublinkTimetableVisible, setIsSublinkTimetableVisible] = useState(
    false
  );
  const [progressPoints, setProgressPoints] = useState(0);
  const [kid, setKid] = useState<IScholars>();
  const dispatch = useDispatch();
  const history = useHistory();

  const openLiteracyModal = useCallback(
    (url: string) => {
      literacyModalIssuer = url;
      dispatch(showLiteracyModal());
    },
    [dispatch]
  );

  useEffect(() => {
    if (literacyModalResult) {
      dispatch(hideLiteracyModal());
      history.push(literacyModalIssuer);
    }
  }, [literacyModalResult, history, dispatch]);

  useEffect(() => {
    const activeKid = units?.find((u) => u.id === activeScholarId);
    if (activeKid) {
      setKid(activeKid);
    }
  }, [units, activeScholarId]);

  useEffect(() => {
    if (location.pathname.includes('/onboarding/choose-map/')) {
      setIsSublinkMapVisible(true);
    } else {
      setIsSublinkMapVisible(false);
    }
    if (location.pathname.includes('/onboarding/timetable')) {
      setIsSublinkTimetableVisible(true);
    } else {
      setIsSublinkTimetableVisible(false);
    }
    // get progress ppoints
    if (location.pathname.includes('/onboarding/profile')) {
      setProgressPoints(15);
    }
    if (location.pathname.includes('/onboarding/choose-map/')) {
      setProgressPoints(30);
    }
    if (location.pathname.includes('/onboarding/choose-map/switch-template')) {
      setProgressPoints(65);
    }
    if (location.pathname.includes('/onboarding/timetable')) {
      setProgressPoints(75);
    }
    if (location.pathname.includes('/onboarding/timetable/resources')) {
      setProgressPoints(80);
    }
    if (location.pathname.includes('/onboarding/timetable/review-map')) {
      setProgressPoints(85);
    }
    if (location.pathname.includes('/onboarding/timetable/review-home')) {
      setProgressPoints(90);
    }
    if (
      location.pathname.includes(
        '/onboarding/timetable/signin-with-credentials'
      )
    ) {
      setProgressPoints(100);
    }
  }, [location]);

  const scholarOrAnetapack = userType === 'parent' ? 'scholar' : 'Anetapack';
  const kidAvatar = location.state?.mode === 'create' ? '' : kid?.avatar;

  return (
    <div className={styles.sideBar}>
      <UserInfo
        userName="Anetapack"
        progress={progressPoints}
        avatar={kidAvatar || ''}
      />
      <div>
        <div className={styles.navigation}>
          <NavLink
            className={styles.link}
            activeClassName={styles.activeLink}
            to="/onboarding/profile"
          >
            <Profile width={20} height={20} fill="#fff" />
            <span>
              {location.state?.mode === 'create'
                ? `Create ${scholarOrAnetapack} profile`
                : `Edit ${scholarOrAnetapack} profile`}
            </span>
          </NavLink>
          {userType === 'parent' && (
            <NavLink
              className={styles.link}
              activeClassName={styles.activeLink}
              to="/onboarding/choose-map/"
            >
              <Game width={20} height={20} color="#fff" />
              <span>Choose map Template</span>
            </NavLink>
          )}
          {isSublinkMapVisible && (
            <div className={styles.subLinksBlock}>
              {/* <NavLink */}
              {/*  className={styles.subLink} */}
              {/*  activeClassName={styles.activeSubLink} */}
              {/*  to="/onboarding/choose-map/switch-template" */}
              {/* > */}
              {/*  <span>Switch map type</span> */}
              {/* </NavLink> */}
            </div>
          )}
          <NavLink
            className={styles.link}
            activeClassName={styles.activeLink}
            to="/onboarding/timetable"
          >
            <TimeSquare width={20} height={20} color="#fff" />
            <span>
              {location.state?.mode === 'create' || _.isEmpty(units)
                ? 'Add timetable and links'
                : 'Timetable and links'}
            </span>
          </NavLink>
          {isSublinkTimetableVisible && (
            <div className={styles.subLinksBlock}>
              <NavLink
                className={styles.subLink}
                activeClassName={styles.activeSubLink}
                to="/onboarding/timetable/resources"
              >
                <span>Build Resource Homeroom Map</span>
              </NavLink>
              {/* <NavLink
                className={`${styles.subLink} ${
                  location.pathname.includes('review-home')
                    ? styles.activeSubLink
                    : ''
                }`}
                activeClassName={styles.activeSubLink}
                to="/onboarding/timetable/review-map"
              >
                <span>Review maps</span>
              </NavLink> */}
              {userType === 'parent' && (
                <NavLink
                  className={styles.subLink}
                  activeClassName={styles.activeSubLink}
                  to="/onboarding/timetable/signin-with-credentials"
                >
                  <span>Confirm Sign-in Credentials</span>
                </NavLink>
              )}
            </div>
          )}
          <a
            className={styles.link}
            onClick={() => {
              if (userType === 'parent') {
                openLiteracyModal('/dashboard/scholars');
              } else {
                history.push('/dashboard/scholars');
              }
            }}
            role="button"
            onKeyDown={() => null}
            tabIndex={0}
          >
            <Dashboard width={20} height={20} color="#fff" />
            <span>
              {userType === 'parent'
                ? `Parent's dashboard`
                : `Teacher's dashboard`}
            </span>
          </a>
        </div>
      </div>
      <NavLink to={userType === 'teacher' ? '/process-steps-admin' : '/map'}>
        <button className={buttons.sideBarButton} type="button">
          {userType === 'teacher' ? 'Save and continue later' : 'Go To The Map'}
        </button>
      </NavLink>
    </div>
  );
};

export default connect(mapStateToProps)(SideBar);
